/* Shared progressive enhancements. Shopify owns submission and consent outcomes. */
(() => {
  const storage = {
    get(key) { try { return localStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch { /* Private browsing may disable storage. */ } }
  };
  const mobile = matchMedia('(max-width: 1000px)');
  const newsletterSelector = '#newsletter_custom, #newsletter_custom_mobile, #newsletter_custom_mobile_1';
  const initialized = new WeakSet();
  const backgroundObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) { loadBackground(target); backgroundObserver.unobserve(target); }
    });
  }) : null;

  function loadBackground(element) {
    const source = element.dataset.bg;
    if (!source) return;
    try {
      const url = new URL(source, location.href);
      if (!['https:', 'http:'].includes(url.protocol)) return;
      element.style.backgroundImage = `url(${JSON.stringify(url.href)})`;
      element.removeAttribute('data-bg');
    } catch { /* Leave the fallback background when a merchant URL is invalid. */ }
  }

  function syncEbookLinks() {
    const target = mobile.matches ? 'newsletter_custom_mobile_1' : 'newsletter_custom';
    document.querySelectorAll('.go_to_ebook').forEach((link) => {
      link.hash = target;
    });
  }

  function init(root = document) {
    root.querySelectorAll('.lazy-bg[data-bg]').forEach((element) => {
      if (backgroundObserver) backgroundObserver.observe(element);
      else loadBackground(element);
    });
    const signedIn = document.body.dataset.customerSignedIn === 'true';
    const subscribed = document.body.dataset.customerMarketing === 'true' || (!signedIn && storage.get('newsletterSubmitted') === 'true');
    root.querySelectorAll('.newsletter_custom_form').forEach((form) => { form.style.display = subscribed ? 'none' : 'grid'; });
    root.querySelectorAll('.already_accepted_newsletter').forEach((message) => { message.style.display = subscribed ? 'grid' : 'none'; });
    root.querySelectorAll(newsletterSelector).forEach((section) => {
      if (initialized.has(section)) return;
      initialized.add(section);
      section.querySelector('svg')?.addEventListener('click', () => section.remove());
      section.querySelector('form')?.addEventListener('submit', () => storage.set('newsletterSubmitted', 'true'));
    });
    syncEbookLinks();
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const consentButton = event.target.closest('#shopify-pc__banner__btn-accept, #shopify-pc__prefs__header-accept');
    if (consentButton) {
      storage.set('shopify_consent', 'granted');
      if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', { ad_storage: 'granted', analytics_storage: 'granted', personalization_storage: 'granted' });
      }
    }
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
    let id;
    try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const headerContainer = document.getElementById('header_container_custom');
    const stickyHeader = headerContainer?.closest('.shopify-section-group-header-group') || headerContainer;
    const headerRect = stickyHeader?.getBoundingClientRect();
    const headerOffset = headerRect && ['sticky', 'fixed'].includes(getComputedStyle(stickyHeader).position) ? headerRect.height : 0;
    window.scrollTo({
      top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerOffset),
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
    if (location.hash !== url.hash) history.pushState(null, '', url.hash);
  }, { capture: true });
  mobile.addEventListener('change', syncEbookLinks);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
